<template>
    <div class="video-box">
        <h3 class="caption">{{videoData.caption}}</h3>
        <div class="imgbox">
            <div class="item-box" v-for='(item,index) in videoData.itemData' :key='index'>
                <div class="img" :style='{backgroundImage:"url("+item.url+")"}'></div>
                <div class="imgcaption">{{item.caption}}</div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'Video',
        data() {
            return {
                videoData: {
                    caption: '产品拍摄案例 ...',
                    itemData: [
                        {
                            url: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/comi/11e1b87b7ac53ffcb23c020a20c90ae070a0fc88285d1-SZege3.jpg',
                            caption: '眼镜行业'
                        },
                        {
                            url: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/comi/ce7ec06add257a4ef66e92821844a9bdea88ab8e15cf01-BIJ3h8.jpg',
                            caption: '锁具行业'
                        },
                        {
                            url: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/comi/O1CN01aVuzAk2MMrYtNUJ3D_!!740469814.jpg',
                            caption: '阀门行业'
                        },
                        {
                            url: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/comi/4d914b87103029.5dae07d87dc90.jpg',
                            caption: '卫浴行业'
                        },
                        {
                            url: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/comi/686401f52b45cdd1f18253260ee695179b0694e89dfc4-YnogPR.jpg',
                            caption: '灯具行业'
                        },
                        {
                            url: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/comi/ebd29df12e4fe581a7b586716231db032229b90434db6-hkRPSz.jpg',
                            caption: '服饰行业'
                        }
                    ]
                }
            }
        }
    }
</script>
<style scoped>
    .video-box {
        width: 85.4%;
        margin: 0 auto;
        padding-bottom: 145px;
    }

    .caption {
        max-width: 242px;
        font-size: 40px;
        font-weight: bold;
        line-height: 122.5%;
        color: rgba(28, 28, 28, 1);
    }

    .imgbox {
        margin-top: 75px;
        width: 100%;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        grid-column-gap: 16px;
        grid-row-gap: 42px;
    }

    .item-box {
        height: auto;
    }

    .img {
        height: 17.7vw;
        background: #666666 no-repeat center;
        background-size: cover;
    }

    .imgcaption {
        background-color: #ffffff;
        font-size: 24px;
        text-align: center;
        font-weight: bold;
        padding: 5%;
        color: rgba(102, 102, 102, 1);
        letter-spacing: 1px;
    }

    @media(max-width: 995px) {
        .video-box {
            width: 100%;
            padding-bottom: 5%;
        }

        .caption {
            max-width: 100%;
            font-size: 24px;
            text-align: center;
            padding: 5%;
        }

        .imgbox {
            margin-top: 0px;
            width: 100%;
            display: grid;
            grid-template-columns: 1fr;
            grid-row-gap: 0;
        }

        .img {
            height: 50vw;
        }

        .imgcaption {
            font-size: 16px;
        }
    }

    /* @media(max-width: 1023px) {
        .video-box {
            width: 100%;
            padding: 5%;
        }

        .imgbox {
            width: 100%;
            grid-template-columns: 1fr;
        }

        .item-box {
            height: auto;
        }

        .img {
            height: 1040px;
        }

        .imgcaption {
            font-size: 50px;
            line-height: 416%;
        }
    } */
</style>


// WEBPACK FOOTER //
// src/components/main/project/video.vue